module.exports = __webpack_public_path__ + "dashboard/img/pytanie.9af172adc575b087d089172609a77231.svg";